<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getRootTranslationCategories, saveCategoryTranslation } from '../helper';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


const route = useRoute();
const router = useRouter();
const currentCategoryId = ref(route.params.category) as any;
const rootCategories = ref([]);
const targetCategories = ref([]);
const rootLanguageId = ref(import.meta.env.VITE_ADMIN_DEFAULT_TRANSLATION_ID)
const targetLanguageId = ref(Array.isArray(route.params.translation) ? route.params.translation[0] : route.params.translation)
const isSaving = ref(false);


const saveCategory = async () => {
    isSaving.value = true;
    await saveCategoryTranslation(targetLanguageId.value, currentCategoryId.value, targetCategories.value[currentCategoryId.value]);
    isSaving.value = false;
    router.go(-1);
}

const checkIFCategoryIsUndefined = async (category: any) => {
    if (targetCategories.value[currentCategoryId.value] === undefined) {
        targetCategories.value[currentCategoryId.value] = {
            name: ''
        }
    }
}

onMounted( async () => {
    rootCategories.value = await getRootTranslationCategories(rootLanguageId.value);
    targetCategories.value = await getRootTranslationCategories(targetLanguageId.value);
    await checkIFCategoryIsUndefined(targetCategories.value[currentCategoryId.value]);
});
</script>

<template>
    <div>
        <div class="row col-12 justify-content-center mb-3">
            <div class="col text-center">
                <Button class="w-30 p-button-tuev" label="Save" @click="saveCategory" iconPos="left" :loading="isSaving">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'save']" />
                    </template>
                </Button>
            </div>
        </div>

        <div v-if="rootCategories[currentCategoryId] && targetCategories[currentCategoryId]">
        <Card class="mb-3">
            <template #title>
                Root Language
            </template>
            <template #content>
                <div v-html="rootCategories[currentCategoryId].name"></div>
            </template>
        </Card>
        <Card class="mb-3">
            <template #title>
                Target Language
            </template>
            <template #content>
                <Textarea fluid v-model="targetCategories[currentCategoryId].name"></Textarea>
            </template>
        </Card>
        </div>
    </div>
</template>
